import Vue from 'vue'
import Router from 'vue-router'
import gtagjs from 'vue-gtagjs'
import Index from '@/components/Index'
import Tickets from '@/components/Tickets'
import AGB from '@/components/Agb'
import Impressum from '@/components/Impressum'
import TooLate from '@/components/TooLate'
import DvdMakingOf from '@/components/DvdMakingOf'
import RedirectBadHall from '@/components/Redirect/BadHall'
import RedirectRied from '@/components/Redirect/Ried'
import Dvd from '@/components/Dvd'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      redirect: '/de'
    },
    {
      path: '/badhall',
      name: 'BadHall',
      component: RedirectBadHall,
      meta: {
        analytics: 'manual'
      }
    },
    {
      path: '/ried',
      name: 'RiedImInnkreis',
      component: RedirectRied,
      meta: {
        analytics: 'manual'
      }
    },
    {
      path: '/de',
      name: 'de-Main',
      component: Index
    },
    {
      path: '/en',
      name: 'en-Main',
      component: Index
    },
    {
      path: '/es',
      name: 'es-Main',
      component: Index
    },
    {
      path: '/nl',
      name: 'nl-Main',
      component: Index
    },
    {
      path: '/de/info',
      name: 'de-Infos',
      component: Index
    },
    {
      path: '/en/info',
      name: 'en-Infos',
      component: Index
    },
    {
      path: '/es/info',
      name: 'es-Infos',
      component: Index
    },
    {
      path: '/nl/info',
      name: 'nl-Infos',
      component: Index
    },
    {
      path: '/de/termine',
      name: 'de-Termine',
      component: Index
    },
    {
      path: '/en/dates',
      name: 'en-Termine',
      component: Index
    },
    {
      path: '/es/eventos',
      name: 'es-Termine',
      component: Index
    },
    {
      path: '/nl/data',
      name: 'nl-Termine',
      component: Index
    },
    {
      path: '/de/details',
      name: 'de-Details',
      component: Index
    },
    {
      path: '/en/details',
      name: 'en-Details',
      component: Index
    },
    {
      path: '/es/detalles',
      name: 'es-Details',
      component: Index
    },
    {
      path: '/nl/details',
      name: 'nl-Details',
      component: Index
    },
    {
      path: '/de/tickets/',
      name: 'de-Tickets',
      component: Index
    },
    {
      path: '/en/tickets/',
      name: 'en-Tickets',
      component: Index
    },
    {
      path: '/es/entradas/',
      name: 'es-Tickets',
      component: Index
    },
    {
      path: '/nl/tickets/',
      name: 'nl-Tickets',
      component: Index
    },
    {
      path: '/de/tickets/:id',
      name: 'de-Ticketbuchung',
      component: Tickets,
      props: true
    },
    {
      path: '/en/tickets/:id',
      name: 'en-Ticketbuchung',
      component: Tickets,
      props: true
    },
    {
      path: '/es/entradas/:id',
      name: 'es-Ticketbuchung',
      component: Tickets,
      props: true
    },
    {
      path: '/nl/tickets/:id',
      name: 'nl-Ticketbuchung',
      component: Tickets,
      props: true
    },
    {
      path: '/de/agb',
      name: 'AGB',
      component: AGB
    },
    {
      path: '/de/impressum',
      name: 'de-Impressum',
      component: Impressum
    },
    {
      path: '/en/legal',
      name: 'en-Impressum',
      component: Impressum
    },
    {
      path: '/es/imprenta',
      name: 'es-Impressum',
      component: Impressum
    },
    {
      path: '/nl/impressum',
      name: 'nl-Impressum',
      component: Impressum
    },
    {
      path: '/toolate',
      name: 'TooLate',
      component: TooLate
    },
    {
      path: '/dvd-making-of',
      name: 'DvdMakingOf',
      component: DvdMakingOf
    },
    {
      path: '/DVD',
      name: 'Dvd',
      component: Dvd
    }
  ]
});

router.afterEach(to => {
  if (to.meta.analytics === "manual") {
    gtagjs((cb) => {
      cb(to.fullPath);
    }, "UA-41500249-9", {
      gtagOpt: {
        'send_page_view': false
      }
    });
  } else {
    gtagjs((cb) => {
      cb(to.fullPath);
    }, "UA-41500249-9");
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js